// formatAvailableLegs — pure rendering of a flight list into an "ORIG->DEST" summary.
//
// Extracted verbatim from `FlightLookup.js` (module-level `formatAvailableLegs`)
// as part of the behavior-preserving refactor (issue #240). Used to build the
// descriptive "Available legs: ..." text in the no-match error message.
//
// Totality mirrors the source exactly: the source called `flights.map(...)`
// directly with no guard for a missing array, so no guard is added here —
// passing a non-array reproduces the same behavior as the original.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

import toIATA from './toIATA.js';

/**
 * Builds a human-readable, comma-separated string of available legs.
 *
 * @param {Array<Object>} flights - Flight objects carrying `origin`/`destination`.
 * @returns {string} A string like `"DFW->LAX, LAX->JFK"`.
 */
export function formatAvailableLegs(flights) {
  return flights.map(function(f) {
    return toIATA(f.origin) + '->' + toIATA(f.destination);
  }).join(', ');
}

export default formatAvailableLegs;
